import React from 'react';

import { Box, BoxProps, Button, Link, Text } from '@opendoor/bricks/core';

import { AccountFormHeader, AccountFormWrapper, FormWrapper } from './shared';

const CheckEmailIcon: React.FC<BoxProps> = (props) => (
  <Box
    background="url('https://imgdrop.imgix.net/6a54d2daabd44c09b455579cfe07f575.svg') no-repeat"
    height="50px"
    width="80px"
    marginBottom={7}
    {...props}
  />
);

export interface ISetupAccountFormProps {
  /**
   * Name of the form in analytics events, should be unique within the app
   * Convention: {appName}-{accountFormName} or {appName}-{resetPasswordFormName}
   */
  analyticsName: string;
  email: string;
  hasGeneratedPassword?: boolean;
  onResetValidEmail: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  requestResetPassword?: (email: string) => void;
}

export default class CheckEmailForm extends React.Component<ISetupAccountFormProps> {
  public render() {
    const { analyticsName, email, hasGeneratedPassword, onResetValidEmail, requestResetPassword } =
      this.props;
    return (
      <AccountFormWrapper textAlign="left">
        <CheckEmailIcon />
        <FormWrapper>
          <AccountFormHeader>
            {hasGeneratedPassword ? 'Set up your account' : 'Check your email'}
          </AccountFormHeader>
          <Text>
            {hasGeneratedPassword
              ? 'First, check your email and click the link to set up your password. We emailed a link to'
              : "We've sent reset password instructions to"}
            <Text fontWeight="bold" as="strong" px={2}>
              {email}
            </Text>
            .
          </Text>
          {requestResetPassword && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <Link
              onClick={(_) => requestResetPassword(email)}
              type="submit"
              fontWeight="semibold"
              fontSize="s2"
              mt={5}
              mb={9}
              analyticsName={`${analyticsName}-resend-reset-password-email`}
              aria-label={'Sends a request to resend the reset password email'}
            >
              Resend email
            </Link>
          )}
          <Text>Once you've reset your password, sign in again.</Text>
          <Button
            variant="link"
            onClick={onResetValidEmail}
            analyticsName={`${analyticsName}-sign-in-after-reset-password`}
            aria-label=""
            data-testid="sign-in-after-reset-password"
            fontWeight="semibold"
            backgroundColor="transparent"
          >
            Sign in
          </Button>
        </FormWrapper>
      </AccountFormWrapper>
    );
  }
}
